// extracted by mini-css-extract-plugin
export default {"loadMoreButton":"PostCommentsForCommentQueries_loadMoreButton__ey0tP"};